<ng-template
    let-nodes="nodes"
    #tpl
>
    <ng-container *ngFor="let e of nodes">
        <div
            [style.padding-left]="'calc(1.6rem * ' + e.depth + ')'"
            *ngIf="!e.hidden"
        >
            <div class="d-flex">
                <div
                    class="insight-expand"
                    *ngIf="localState.atLeastOneHasChild"
                >
                    <button
                        type="button"
                        class="btn bg-transparent p-0"
                        tabIndex="-1"
                        (click)="_onExpandClick(e.key)"
                        *ngIf="e.depth === 0 && e.children?.length > 0"
                    >
                        <cmps-icon
                            [svgIcon]="
                                localState.states[e.key].expanded
                                    ? 'chevron-down'
                                    : !localState.states[e.key].expanded
                                    ? 'chevron-right'
                                    : null
                            "
                        ></cmps-icon>
                    </button>
                </div>
                <div
                    class="custom-control custom-checkbox custom-control-inline"
                >
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        [id]="'layoutNode' + e.key + e.rand"
                        [checked]="localState.states[e.key].checked"
                        [disabled]="localState.states[e.key].disabled"
                        [indeterminate]="
                            e.depth > 0 || standAloneParent
                                ? null
                                : _checkSelected(e.key, 'some')
                        "
                        (click)="_onClick($event, e, e.key)"
                        (change)="_onChange($event, e.key)"
                    />
                    <label
                        class="custom-control-label"
                        [htmlFor]="'layoutNode' + e.key + e.rand"
                        (click)="_onClick($event, e, e.key)"
                    >
                        {{ e.label }}
                    </label>
                </div>
            </div>
            <ng-container *ngIf="localState.states[e.key].expanded">
                <ng-container
                    *ngTemplateOutlet="tpl; context: { nodes: e.children }"
                ></ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<div class="insight-nested-node-select">
    <ng-container
        *ngTemplateOutlet="tpl; context: { nodes: nodes }"
    ></ng-container>
</div>
